"use client";

import * as React from "react";
import { motion, HTMLMotionProps } from "framer-motion";

export interface CardProps extends Omit<HTMLMotionProps<"div">, "ref"> {
  hoverGlow?: boolean;
  glass?: boolean;
  className?: string;
  glowColor?: string;
  children?: React.ReactNode;
  innerClassName?: string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      children,
      hoverGlow = false,
      glass = true,
      className = "",
      glowColor,
      innerClassName = "",
      ...props
    },
    ref
  ) => {
    const cardRef = React.useRef<HTMLDivElement>(null);

    React.useImperativeHandle(ref, () => cardRef.current!);

    const baseClass = "relative rounded-xl overflow-hidden transition-all duration-300";
    const glassClass = glass ? "glassmorphism shadow-sm hover:shadow-md" : "bg-white dark:bg-slate-900 border border-border-muted";

    const isGrid = innerClassName.includes("grid");
    const layoutClass = isGrid ? "" : "flex flex-col";

    return (
      <motion.div
        ref={cardRef}
        className={`${baseClass} ${glassClass} ${className}`}
        whileHover={{ y: -4 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        {...(props as any)}
      >
        <div className={`relative z-10 p-6 sm:p-8 h-full ${layoutClass} ${innerClassName}`}>{children}</div>
      </motion.div>
    );
  }
);

Card.displayName = "Card";
